module.exports = __webpack_public_path__ + "7ca824cab820c8c7cf31db61b1edfe71.pdf";